module.exports = __webpack_public_path__ + "static/media/img-mygood-product-6@2x.82b08626.png";